import React from 'react'

const Grid = ({ items }) => {
  return <div className="row grid">{items}</div>
}

export default Grid
